// SR3-REG-3 (MA-28c) — per-vertical demo deep-link builder for the superadmin console.
//
// The public interactive demo is the REAL admin app on a separate, disposable deployment
// (demo.ospelio.ro/demo/start). /demo/start auto-creates a short-lived demo session; an optional
// `?vertical=` picks WHICH vertical's seeded demo tenant the visitor lands in. The console's Demo
// Tenant Matrix links here so an operator can open a vertical's live public demo in one click.
//
// This replaces the stray, ZERO-consumer copy that previously sat in frontend/src/utils/demoUrl.ts
// (the onboarding site keeps its own copy in onboarding-frontend/src/demoUrl.ts). Consumed for real
// by DemoMatrixPage.

/** Origin of the disposable demo deployment (mirrors the onboarding site's demo CTA). */
export const DEMO_ORIGIN = 'https://demo.ospelio.ro';

/**
 * Build the demo-start URL for a given vertical.
 *
 * @param vertical vertical slug or code (e.g. 'fastfood', 'night-club', 'events'); blank/null -> generic demo.
 * @param origin   demo deployment origin; pass '' for a same-origin RELATIVE link. Defaults to DEMO_ORIGIN.
 * @returns e.g. 'https://demo.ospelio.ro/demo/start?vertical=fastfood' or '/demo/start'.
 */
export function demoUrl(vertical?: string | null, origin: string = DEMO_ORIGIN): string {
  const base = `${origin || ''}/demo/start`;
  const slug = (vertical ?? '').trim().toLowerCase();
  return slug ? `${base}?vertical=${encodeURIComponent(slug)}` : base;
}
